export const
    dyk_0 = require('./dyk_0.svg'),
    dyk_1 = require('./dyk_1.svg'),
    dyk_2 = require('./dyk_2.svg')